import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestScannerQueuePost = {
    path: "/scanner/queue",
    method: RouteHttpVerb.POST
};
